export function getPathname() {
  return window.location.pathname;
}

export function getFullUrlPath() {
  return window.location.pathname + window.location.search;
}
